import { apiClient } from '@/shared/api/axios-instance';
import type { 
    DashboardKpisResponse, 
    DashboardAnalyticsResponse, 
    DashboardAdsResponse, 
    ApiResponse 
} from '../types/dashboard.types';

export interface DashboardQueryParams {
    startDate?: string;
    endDate?: string;
    compareStartDate?: string;
    compareEndDate?: string;
    timezone?: string;
    timeframe?: string;
}

export interface PaginatedQueryParams extends DashboardQueryParams {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    sortBy?: string;
    sortDirection?: string;
    [key: string]: any;
}

class DashboardService {
    async getKpis(params: DashboardQueryParams): Promise<ApiResponse<DashboardKpisResponse>> {
        const response = await apiClient.get('/admin/dashboard/kpis', { params });
        return response.data;
    }

    async getAnalytics(params: DashboardQueryParams): Promise<ApiResponse<DashboardAnalyticsResponse>> {
        const response = await apiClient.get('/admin/dashboard/analytics', { params });
        return response.data;
    }

    async getMerchants(params: PaginatedQueryParams): Promise<ApiResponse<any>> {
        const response = await apiClient.get('/admin/dashboard/merchants', { params });
        return response.data;
    }

    async getTransactions(params: PaginatedQueryParams): Promise<ApiResponse<any>> {
        const response = await apiClient.get('/admin/dashboard/transactions', { params });
        return response.data;
    }

    async getInvoices(params: PaginatedQueryParams): Promise<ApiResponse<any>> {
        const response = await apiClient.get('/admin/dashboard/invoices', { params });
        return response.data;
    }

    async getRenewals(params: PaginatedQueryParams): Promise<ApiResponse<any>> {
        const response = await apiClient.get('/admin/dashboard/renewals', { params });
        return response.data;
    }

    async getAds(params: DashboardQueryParams): Promise<ApiResponse<DashboardAdsResponse>> {
        const response = await apiClient.get('/admin/dashboard/ads', { params });
        return response.data;
    }
}

export const dashboardService = new DashboardService();
